import {
  SourcingLocationType,
  SourcingRequestStatus,
  SRMatchStatus,
} from './enums';
import { EntityTypes } from './enums/entityTypes';
import { Coordinates } from './org';
import { SupplierRequestNAICS } from './supplierRequest';

export interface SourcingRequest {
  requestId: string;
  userId: string;
  userEmail?: string;
  sourcingRequestFile?: SourcingRequestDoc;
  entityType: EntityTypes.sourcingRequest;
  projectName: string;
  prompt: string;
  entry?: string;
  locationRequirements?: string[];
  logisticsRequirements?: string[];
  geographicRequirements?: string[];
  industryRequirements?: string[];
  productsAndServicesRequirements?: string[];
  demographicRequirements?: string[];
  regulatoryRequirements?: string[];
  otherRequirements?: string[];
  relatedNAICSCodes?: SupplierRequestNAICS[];
  relatedGeographies?: SourcingRequirement[];
  relatedIndustries?: SourcingRequirement[];
  relatedProductsAndServices?: SourcingRequirement[];
  relatedLocations?: SourcingLocationRequirement[];
  uploadDocument?: boolean;
  status: SourcingRequestStatus;
  matchStatus: SRMatchStatus;
  matchesNotified?: boolean;
  matchCount?: number;
  viewedMatches: boolean;
  feedbackSubmitted?: boolean;
  useKnowledgeBase: boolean;
  matchCandidateCount?: number;
  matchCandidateCompleted?: number;
  created: number;
  lastUpdated: number;
}

export interface SourcingRequestDoc {
  fileName: string;
  key: string;
  contentType: string;
}
export interface SourcingRequirement {
  name: string;
  originalRequirement: string;
  confidence: number;
}

export interface SourcingLocationRequirement {
  originalRequirement: string;
  formatedRequirement: string;
  type: SourcingLocationType;
  polygon: Coordinates[];
  coordinates: Coordinates;
}

export interface CreateSourcingRequestInput {
  userId: string;
  userEmail?: string;
  sourcingRequestFile?: SourcingRequestDoc;
  projectName: string;
  prompt: string;
  entry?: string;
  locationRequirements?: string[];
  logisticsRequirements?: string[];
  geographicRequirements?: string[];
  productsAndServicesRequirements?: string[];
  demographicRequirements?: string[];
  regulatoryRequirements?: string[];
  industryRequirements?: string[];
  otherRequirements?: string[];
  uploadDocument?: boolean;
}

//JSONSchema for CreateSourcingRequestInput
export const CreateSourcingRequestInputSchema = {
  type: 'object',
  properties: {
    userId: { type: 'string' },
    userEmail: { type: 'email' },
    projectName: { type: 'string' },
    sourcingRequestFile: {
      type: 'object',
      properties: {
        fileName: { type: 'string' },
        key: { type: 'string' },
        contentType: { type: 'string' },
      },
      required: ['fileName', 'key', 'contentType'],
      additionalProperties: false,
    },
    prompt: { type: 'string' },
    locationRequirements: { type: 'array', items: { type: 'string' } },
    logisticsRequirements: { type: 'array', items: { type: 'string' } },
    geographicRequirements: { type: 'array', items: { type: 'string' } },
    productsAndServicesRequirements: {
      type: 'array',
      items: { type: 'string' },
    },
    demographicRequirements: { type: 'array', items: { type: 'string' } },
    regulatoryRequirements: { type: 'array', items: { type: 'string' } },
    industryRequirements: { type: 'array', items: { type: 'string' } },
    otherRequirements: { type: 'array', items: { type: 'string' } },
  },
  required: ['userId', 'projectName', 'prompt'],
  additionalProperties: false,
};

export interface CreateSourcingRequestAPIInput {
  entry?: string;
  email?: string;
  uploadDocument?: boolean;
  sourcingRequestFile?: SourcingRequestDoc;
}

//JSONSchema for CreateSourcingRequestAPIInput
export const CreateSourcingRequestAPIInputSchema = {
  type: 'object',
  properties: {
    entry: { type: 'string', minLength: 10 },
    email: { type: 'email' },
    uploadDocument: { type: 'boolean' },
    sourcingRequestFile: {
      type: 'object',
      properties: {
        fileName: { type: 'string' },
        key: { type: 'string' },
        contentType: { type: 'string' },
      },
      required: ['fileName', 'key', 'contentType'],
      additionalProperties: false,
    },
  },
  additionalProperties: false,
};

export class ExceededSourcingRequestLimitError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ExceededSourcingRequestLimitError';
  }
}
